export const Endpoints = {
    auth: {
        login: "api/auth/login",
        check_token: "api/auth/checktoken/",
        checkToken: "/api/auth/:clickup-token/:email",
    },
    user: {
        post_and_getall: "api/user",
        putUser_deleteUser: "api/user/:email",
        get_getUserTable: "api/user/generaltable",
        get_LP_users: "api/user/lp/people",
        get_LP_times: "api/user/lp/times"
    },
    area: {
        global: "api/area",
        team: "api/area/:id/isTeam",
        isteam: "api/area?isTeam=true",
    },
    platform: {
        getall_create: "api/platform",
        put_delete: "api/platform/:id",
    },
    category: {
        getall_create: "api/category",
        put_delete: "api/category/:id",
        addsubcategories: "api/category/:categoryId/subcategory",
    },
    project: {
        getProjectClickup: "api/project/?byClickUp=true",
        create: "api/project",
        getAllProject: "api/project",
        form: "api/project/form?doesGetPlatformInactive=false",
        detail: "api/project/detail/:spaceId",
        finishproject: "api/project/finish/:spaceId",
        hasComment: "api/project/edit/:spaceId/comments",
        reactiveProject: "api/project/reactive/:spaceId",
        addHours: "api/project/time",
        getTaskEstimate: "api/project/estimated/:spaceId",
        reactive: "api/project/reactive/:spaceId",
        entries: "api/project/entries/spaces",
        tasks: "api/project/detail/tasks/:spaceId",
        updatetime: "api/project/updateConcluedTime/:spaceId",
        download: "api/project/download/:year",
        overtime: "api/project/overtime/table/:year",
        alllProjectsByYear: "api/project/year/:year",
        canceledComment: "api/project/cancel",
        getEntriesBySpace: "api/project/detail/info/:spaceId",
        simulation: "api/project/simulation/detail/:spaceId",
        proyection: "api/project/projection/:spaceId",
        analisys: "api/project/analysis/admin/:year",
        deleteProject: "api/project/delete/:spaceId",
        deletepermanentProject: "api/project/deletepermanent/:spaceId",
        unlinkProject: "api/project/unlink/:spaceId",
        updateTaskByClickupSpace: "api/project/tasks/migration",
        updateTaskByClickupSpaceV2: "api/webhook/task/migration/v2",
        debug: {
            taskcount: "api/webhook/task/count/:spaceId",
        },
        comments: {
            get: "api/project/comments/task/:spaceId"
        },
        tableWeeks: "api/project/graph/weekanalitycs/:year",
    },
    extratime: {
        save: "api/project/extratime",
        edit: "api/project/extratime/:extraTimeId",
    },
    extraresource: {
        create: "api/project/extraresources",
        delete: "api/project/extraresources/:resourceId",
    },
    updateProject: {
        infoproject: "api/project/edit/:spaceId/basics",
        infocliente: "api/project/edit/:spaceId/client",
        budgethours: "api/project/edit/:spaceId/hours",
        dates: "api/project/edit/:spaceId/dates",
        team: "api/project/edit/:spaceId/team",
        calculatedHours: "api/project/edit/:spaceId/calculated-hours",
    },
    clickup: {
        getWorkSpace: "api/click/workspace",
    },
    graph: {
        category: "api/project/graph/categories",
        size: "api/project/graph/size",
        leaders: "api/project/graph/leaders",
        leaderProjects: "api/project/graph/leader/projects/:year",
        leadersProjects: "api/project/graph/leaders/table",
        sectionArea: "api/section/getAreas",
        section: "api/section/getTaskByYear",
        reloadSectionById: "api/section/reload/:sectionId",
        reloadSection: "api/section/reloadall",
        clickupSpaceInmersys: "api/section/clickupSpaceInmersys",
        clickupListBySpaceInmersys: "api/section/getListBySpaces",
        sectionCreate: "api/section/create",
        sectionUpdate: "api/section/update/:sectionId",
        sectionDelete: "api/section/delete/:sectionId",
        projectArea: "api/project/graph/project-area",
        semaforo: "api/backup/status/year/:year",
        saveSemaforo: "api/backup/status",
    },
    pauseReason: {
        getAll: "api/reason",
        updateProject: "api/project/pause/add",
        resetUpdate: "api/project/pause/:pauseId",
        editPause: "api/project/pause/editpause/:pauseId",
        deletePause: "api/project/pause/delete/:pauseId/:spaceId",
    },
    retrospective: {
        comment: "api/project/comments",
        edit: "api/project/comments/update",
        getComment: "api/project/comments/:clickUpSpace",
        delete: "api/project/comments/delete/:id",
        sendEmail: "api/project/comments/emailconclued/:clickUpSpace"
    },
    updateHours: {
        getbackupSpace: "api/updatehours/:spaceId",
        create: "api/updatehours",
        delete: "api/updatehours/hours/:backupId/space/:spaceId",
    },
    projectred: {
        create: "api/project/overtime",
        get: "api/project/overtime/:spaceId",
    },
    simulation: {
        getSimulation: "api/project/simulation/resources/:spaceId",
        create_update: "api/project/simulation/resources/:spaceId",
        get_assets: "api/simulation/asset/:spaceId",
        create_assets: "api/simulation/asset/:spaceId",
        update_assets: "api/simulation/asset",
        create_provider: "api/simulation/provider/:typeUrl/:spaceId",
        edit_provider: "api/simulation/provider/edit/:providerSimulationId",
        get_providers: "api/simulation/provider/:spaceId",
        delete_providers: "api/simulation/provider/edit/:providerSimulationId",
    },
    backlog: {
        getAll: "api/hourcomparative/:spaceId",
        save: "api/hourcomparative/start/",
        finish: "api/hourcomparative/final/",
    },
    tags: {
        get: "api/evaluationtag",
        post: "api/evaluationtag",
        update: "api/evaluationtag/tag/:id"
    }
};
